import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { type SurveyRow } from 'entities/Surveys/model/SurveyRow'
import { SurveysApi } from 'entities/Surveys'

export const deleteSurvey = async (row: SurveyRow, onSuccessDelete: (id: number) => void) => {
  const modalId = nanoid()

  const onClose = () => {
    modalStore.closeModal(modalId)
  }

  const onDelete = async () => {
    try {
      await SurveysApi.deleteSurvey(row.id)
      onSuccessDelete(row.id)
      onClose()
      toastStore.add({
        type: 'success',
        title: 'Survey deleted',
      })
    } catch (error) {
      logger.error(error)
      toastStore.add({
        title: 'Something went wrong',
        desc: 'Please try again',
        type: 'error',
      })
    }
  }

  modalStore.addModal({
    id: modalId,
    type: ModalTypeList.ALERT,
    title: 'Delete survey?',
    desc: 'This action cannot be undone.',
    width: 280,
    secondaryAction: {
      text: 'Cancel',
      onAction: onClose,
    },
    primaryAction: {
      text: 'Delete',
      onAction: onDelete,
    },
  })
}
